import type { PricingConfigurationFormValues } from './pricingConfigurationSchema';

type Tier = PricingConfigurationFormValues['minimumStayLeadTimeTiers'][number];

/**
 * Beispielsatz unter der Vorlaufstaffel für eine Anreise in zehn Tagen: es greift die Stufe mit dem
 * kleinsten Vorlauf, der noch reicht. Unvollständige Stufen zählen nicht.
 */
export function tierExample(tiers: readonly Tier[], leadDays = 10): string {
  // `Number('')` wäre 0 – ein leeres Feld ist aber keine Stufe „0 Tage“.
  const number = (entry: string) => (entry.trim() === '' ? Number.NaN : Number(entry));
  const valid = tiers
    .map((tier) => ({
      lead: number(tier.daysBeforeArrival),
      nights: number(tier.minimumStayNights),
    }))
    .filter(
      (tier) =>
        Number.isInteger(tier.lead) &&
        Number.isInteger(tier.nights) &&
        tier.lead >= 0 &&
        tier.nights >= 1,
    )
    .sort((left, right) => left.lead - right.lead);
  if (valid.length === 0) return 'Keine Stufe – es gilt immer der reguläre Mindestaufenthalt.';
  const match = valid.find((tier) => leadDays <= tier.lead);
  if (!match) {
    return `Beispiel: Anreise in ${leadDays} Tagen → keine Stufe greift, es gilt der reguläre Mindestaufenthalt.`;
  }
  const nights = match.nights === 1 ? '1 Nacht' : `${match.nights} Nächte`;
  return `Beispiel: Anreise in ${leadDays} Tagen → höchstens ${nights} Mindestaufenthalt.`;
}
